import { useMutation } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { B2B_SERVICE_API } from '../b2bApiClient';

export const CREATE_ACCOUNT_QUERY_KEY = 'create-account-query';

interface ICreateAccountMutation {
  onSuccessCallback: () => void;
  onErrorCallback: (error: IApiError) => void;
}

/**
 * This performs a submit to create account api request.
 */
export function useCreateAccountMutation({
  onSuccessCallback,
  onErrorCallback,
}: Readonly<ICreateAccountMutation>) {
  const { isPending, mutate } = useMutation({
    mutationKey: [CREATE_ACCOUNT_QUERY_KEY],
    mutationFn: B2B_SERVICE_API.postCreateAccountForm,
    onSuccess: onSuccessCallback,
    onError: onErrorCallback,
  });

  return {
    submitCreateAccount: mutate,
    isPending,
  };
}
